import styled from 'styled-components';

export const LimitedWidthCell = styled.td`
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
